import React from 'react';
import PropTypes from 'prop-types';

import { Toolbar as MUIToolbar } from '@mui/material';

export const Toolbar = props => <MUIToolbar {...props} />;

Toolbar.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  component: PropTypes.elementType,
  disableGutters: PropTypes.bool,
  variant: PropTypes.oneOf(['regular', 'dense'])
};

export default Toolbar;
